<div class="epi-container">
    <h4>{{header}}</h4>
    <i class="fa" (click)="visible = !visible" [ngClass]="{'fa-plus': !visible, 'fa-minus': visible}" aria-hidden="true"></i>

    <div *ngIf="visible">
        <ng-content></ng-content>
    </div>
</div>